/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1xLhJbx5VveCXJsMYNxtFb
// Component: 0i0g7bSenwRJ
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/projectcss
import sty from "./PlasmicTabLayout.module.css"; // plasmic-import: 0i0g7bSenwRJ/css

createPlasmicElementProxy;

export const PlasmicTabLayout__VariantProps = new Array("layoutType");

export const PlasmicTabLayout__ArgProps = new Array("tabNav", "tabContent");

const $$ = {};

function PlasmicTabLayout__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "layoutType",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.layoutType
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"tabLayout"}
      data-plasmic-override={overrides.tabLayout}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.tabLayout,
        {
          [sty.tabLayoutlayoutType_horizontalStacked]: hasVariant(
            $state,
            "layoutType",
            "horizontalStacked"
          ),
          [sty.tabLayoutlayoutType_verticalStacked]: hasVariant(
            $state,
            "layoutType",
            "verticalStacked"
          )
        }
      )}
    >
      <div
        data-plasmic-name={"slotTabNav"}
        data-plasmic-override={overrides.slotTabNav}
        className={classNames(projectcss.all, sty.slotTabNav, {
          [sty.slotTabNavlayoutType_horizontalStacked]: hasVariant(
            $state,
            "layoutType",
            "horizontalStacked"
          ),
          [sty.slotTabNavlayoutType_verticalStacked]: hasVariant(
            $state,
            "layoutType",
            "verticalStacked"
          )
        })}
      >
        {renderPlasmicSlot({
          defaultContents: null,
          value: args.tabNav
        })}
      </div>
      <div
        data-plasmic-name={"slotTabContent"}
        data-plasmic-override={overrides.slotTabContent}
        className={classNames(projectcss.all, sty.slotTabContent, {
          [sty.slotTabContentlayoutType_verticalStacked]: hasVariant(
            $state,
            "layoutType",
            "verticalStacked"
          )
        })}
      >
        {renderPlasmicSlot({
          defaultContents: null,
          value: args.tabContent
        })}
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  tabLayout: ["tabLayout", "slotTabNav", "slotTabContent"],
  slotTabNav: ["slotTabNav"],
  slotTabContent: ["slotTabContent"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTabLayout__ArgProps,
          internalVariantPropNames: PlasmicTabLayout__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicTabLayout__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "tabLayout") {
    func.displayName = "PlasmicTabLayout";
  } else {
    func.displayName = `PlasmicTabLayout.${nodeName}`;
  }
  return func;
}

export const PlasmicTabLayout = Object.assign(
  // Top-level PlasmicTabLayout renders the root element
  makeNodeComponent("tabLayout"),
  {
    // Helper components rendering sub-elements
    slotTabNav: makeNodeComponent("slotTabNav"),
    slotTabContent: makeNodeComponent("slotTabContent"),
    // Metadata about props expected for PlasmicTabLayout
    internalVariantProps: PlasmicTabLayout__VariantProps,
    internalArgProps: PlasmicTabLayout__ArgProps
  }
);

export default PlasmicTabLayout;
/* prettier-ignore-end */
